import type * as SchemaTypes from '../../../apolloClient.types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SubmitTeamResilienceAssessmentResultMutationVariables = SchemaTypes.Exact<{
  input: SchemaTypes.SubmitTeamResilienceAssessmentResultInput;
}>;


export type SubmitTeamResilienceAssessmentResultMutation = (
  { __typename: 'Mutation' }
  & { submitTeamResilienceAssessmentResult: (
    { __typename: 'ErrorResponse' }
    & { fields?: SchemaTypes.Maybe<Array<(
      { __typename: 'ErrorOnField' }
      & Pick<SchemaTypes.ErrorOnField, 'field' | 'message'>
    )>> }
  ) | (
    { __typename: 'SubmitTeamResilienceAssessmentResultSuccessfulResponse' }
    & { result?: SchemaTypes.Maybe<(
      { __typename: 'AssessmentResult' }
      & TeamResilienceAssessmentResultFragment
    )> }
  ) }
);

export type TeamResilienceAssessmentResultFragment = (
  { __typename: 'AssessmentResult' }
  & Pick<SchemaTypes.AssessmentResult, 'id' | 'companyId' | 'userId' | 'moduleInstanceId' | 'courseInstanceId' | 'assessmentRunId' | 'createdAt'>
  & { company: (
    { __typename: 'Company' }
    & Pick<SchemaTypes.Company, 'id' | 'name'>
  ), user?: SchemaTypes.Maybe<(
    { __typename: 'SuperAdminUser' }
    & Pick<SchemaTypes.SuperAdminUser, 'id' | 'name' | 'email' | 'isSuperAdmin'>
  ) | (
    { __typename: 'TenantUser' }
    & Pick<SchemaTypes.TenantUser, 'id' | 'name' | 'role' | 'email'>
  )>, moduleInstance?: SchemaTypes.Maybe<(
    { __typename: 'ModuleInstance' }
    & Pick<SchemaTypes.ModuleInstance, 'name'>
  )>, courseInstance?: SchemaTypes.Maybe<(
    { __typename: 'CourseInstance' }
    & Pick<SchemaTypes.CourseInstance, 'name'>
  )>, assessmentRun?: SchemaTypes.Maybe<(
    { __typename: 'AssessmentRun' }
    & Pick<SchemaTypes.AssessmentRun, 'name'>
  )>, result: { __typename: 'BmpResult' } | { __typename: 'CardioRespResult' } | { __typename: 'FinSwimResult' } | { __typename: 'IpptResult' } | { __typename: 'ML360Result' } | { __typename: 'March20kmResult' } | { __typename: 'SartResult' } | { __typename: 'SelfDeterminationResult' } | { __typename: 'SocResult' } | { __typename: 'SpatialPlanningResult' } | { __typename: 'StrengthResult' } | (
    { __typename: 'TeamResilienceResult' }
    & TeamResilienceAssessmentResultDataFragment
  ) | { __typename: 'TrainersNotesResult' } | { __typename: 'VisualReactionResult' } | { __typename: 'WeightResult' } }
);

export type TeamResilienceAssessmentResultDataFragment = (
  { __typename: 'TeamResilienceResult' }
  & { surveys: Array<(
    { __typename: 'TeamResilienceSurveyResult' }
    & Pick<SchemaTypes.TeamResilienceSurveyResult, 'category' | 'subcategory' | 'question'>
    & { scoring: (
      { __typename: 'LikertScaleResult' }
      & TeamResilienceLikertScaleResultFragment
    ) | (
      { __typename: 'RatingScaleResult' }
      & TeamResilienceRatingScaleResultFragment
    ) }
  )>, categoryAverages: Array<(
    { __typename: 'TeamResilienceCategoryAverage' }
    & Pick<SchemaTypes.TeamResilienceCategoryAverage, 'category' | 'maximumPossibleScore' | 'averageScore'>
  )>, subcategoryAverages: Array<(
    { __typename: 'TeamResilienceSubcategoryAverage' }
    & Pick<SchemaTypes.TeamResilienceSubcategoryAverage, 'category' | 'subcategory' | 'maximumPossibleScore' | 'averageScore'>
  )> }
);

export type TeamResilienceLikertScaleResultFragment = (
  { __typename: 'LikertScaleResult' }
  & Pick<SchemaTypes.LikertScaleResult, 'type' | 'score' | 'total' | 'label'>
);

export type TeamResilienceRatingScaleResultFragment = (
  { __typename: 'RatingScaleResult' }
  & Pick<SchemaTypes.RatingScaleResult, 'type' | 'score' | 'minimumValue' | 'maximumValue'>
);

export const TeamResilienceLikertScaleResultFragmentDoc = /*#__PURE__*/ gql`
    fragment TeamResilienceLikertScaleResult on LikertScaleResult {
  type
  score
  total
  label
}
    `;
export const TeamResilienceRatingScaleResultFragmentDoc = /*#__PURE__*/ gql`
    fragment TeamResilienceRatingScaleResult on RatingScaleResult {
  type
  score
  minimumValue
  maximumValue
}
    `;
export const TeamResilienceAssessmentResultDataFragmentDoc = /*#__PURE__*/ gql`
    fragment TeamResilienceAssessmentResultData on TeamResilienceResult {
  surveys {
    category
    subcategory
    question
    scoring {
      __typename
      ... on LikertScaleResult {
        ...TeamResilienceLikertScaleResult
      }
      ... on RatingScaleResult {
        ...TeamResilienceRatingScaleResult
      }
    }
  }
  categoryAverages {
    category
    maximumPossibleScore
    averageScore
  }
  subcategoryAverages {
    category
    subcategory
    maximumPossibleScore
    averageScore
  }
}
    `;
export const TeamResilienceAssessmentResultFragmentDoc = /*#__PURE__*/ gql`
    fragment TeamResilienceAssessmentResult on AssessmentResult {
  id
  companyId
  company {
    id
    name
  }
  userId
  user {
    __typename
    ... on TenantUser {
      id
      name
      role
      email
    }
    ... on SuperAdminUser {
      id
      name
      email
      isSuperAdmin
    }
  }
  moduleInstanceId
  moduleInstance {
    name
  }
  courseInstanceId
  courseInstance {
    name
  }
  assessmentRunId
  assessmentRun {
    name
  }
  result {
    __typename
    ... on TeamResilienceResult {
      ...TeamResilienceAssessmentResultData
    }
  }
  createdAt
}
    `;
export const SubmitTeamResilienceAssessmentResultDocument = /*#__PURE__*/ gql`
    mutation SubmitTeamResilienceAssessmentResult($input: SubmitTeamResilienceAssessmentResultInput!) {
  submitTeamResilienceAssessmentResult(input: $input) {
    ... on SubmitTeamResilienceAssessmentResultSuccessfulResponse {
      result {
        ...TeamResilienceAssessmentResult
      }
    }
    ... on ErrorResponse {
      fields {
        field
        message
      }
    }
  }
}
    ${TeamResilienceAssessmentResultFragmentDoc}
${TeamResilienceAssessmentResultDataFragmentDoc}
${TeamResilienceLikertScaleResultFragmentDoc}
${TeamResilienceRatingScaleResultFragmentDoc}`;
export type SubmitTeamResilienceAssessmentResultMutationFn = Apollo.MutationFunction<SubmitTeamResilienceAssessmentResultMutation, SubmitTeamResilienceAssessmentResultMutationVariables>;

/**
 * __useSubmitTeamResilienceAssessmentResultMutation__
 *
 * To run a mutation, you first call `useSubmitTeamResilienceAssessmentResultMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitTeamResilienceAssessmentResultMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitTeamResilienceAssessmentResultMutation, { data, loading, error }] = useSubmitTeamResilienceAssessmentResultMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitTeamResilienceAssessmentResultMutation(baseOptions?: Apollo.MutationHookOptions<SubmitTeamResilienceAssessmentResultMutation, SubmitTeamResilienceAssessmentResultMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitTeamResilienceAssessmentResultMutation, SubmitTeamResilienceAssessmentResultMutationVariables>(SubmitTeamResilienceAssessmentResultDocument, options);
      }
export type SubmitTeamResilienceAssessmentResultMutationHookResult = ReturnType<typeof useSubmitTeamResilienceAssessmentResultMutation>;
export type SubmitTeamResilienceAssessmentResultMutationResult = Apollo.MutationResult<SubmitTeamResilienceAssessmentResultMutation>;
export type SubmitTeamResilienceAssessmentResultMutationOptions = Apollo.BaseMutationOptions<SubmitTeamResilienceAssessmentResultMutation, SubmitTeamResilienceAssessmentResultMutationVariables>;